export default __webpack_public_path__ + "static/Andy.KrivyBoardOfDirectorsSECRETARYChairMembership_social-587da6946f583cb4e647edc94068fd20.jpg";